import OrganizationResourcesList from "./OrganizationResourcesList";
import OrganizationResourcesEdit from "./OrganizationResourcesEdit";
import OrganizationResourcesCreate from "./OrganizationResourcesCreate";

export default {
    list: OrganizationResourcesList,
    edit: OrganizationResourcesEdit,
    create: OrganizationResourcesCreate,
};
